import { injectable, inject } from 'inversify'

import { YandexMetrikaProvider } from '../providers/YandexMetrikaProvider'
import { AnalyticsService } from '../services'
import { useAnalyticsStore } from '../store'

@injectable()
export class AnalyticsSupport {
  protected store: ReturnType<typeof useAnalyticsStore>

  constructor(
    @inject(AnalyticsService)
    readonly service: AnalyticsService,
    @inject(YandexMetrikaProvider)
    readonly provider: YandexMetrikaProvider,
  ) {
    this.store = useAnalyticsStore()
  }

  /**
   * Загрузить (однократно) публичную конфигурацию аналитики/CMP текущей витрины.
   * Без хоста канала запрос не отправляется: путь обязан содержать showcaseHost.
   */
  async loadConfig() {
    const currentConfig = this.store.config
    if (currentConfig) return currentConfig
    if (!useAppConfig().host) return

    this.store.setConfig(await this.service.getConfig())

    return this.store.config
  }

  /**
   * Инициализировать счётчик, если аналитика включена на канале и сбор разрешён
   * (согласие на «аналитика» дано либо не требуется — ТЗ §5.3, §11.2).
   * Идемпотентно: повторный вызов при уже инициализированном провайдере — no-op
   */
  initMetrikaIfAllowed(analyticsAllowed: boolean) {
    if (this.provider.initialized || !analyticsAllowed) return

    const analytics = this.store.config?.analytics
    if (!analytics?.enabled || !analytics.counterId) return

    this.provider.init({
      counterId: analytics.counterId,
      ecommerceEnabled: Boolean(analytics.ecommerceEnabled),
      webvisorEnabled: Boolean(analytics.webvisorEnabled),
    })
  }
}
